import React from 'react'
import { OrderInfo } from './OrderInfo'

export const Application = () => {
  return <OrderInfo />
}
